"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./GridCol.css");
var GridCol = (function (_super) {
    __extends(GridCol, _super);
    function GridCol(props) {
        return _super.call(this, props) || this;
    }
    GridCol.prototype.render = function () {
        var _a = this.props, width = _a.width, widthForXs = _a.widthForXs, widthForSm = _a.widthForSm, widthForMd = _a.widthForMd, widthForLg = _a.widthForLg, widthForXl = _a.widthForXl, offsetLeft = _a.offsetLeft, offsetLeftForXs = _a.offsetLeftForXs, offsetLeftForSm = _a.offsetLeftForSm, offsetLeftForMd = _a.offsetLeftForMd, offsetLeftForLg = _a.offsetLeftForLg, offsetLeftForXl = _a.offsetLeftForXl, offsetRight = _a.offsetRight, offsetRightForXs = _a.offsetRightForXs, offsetRightForSm = _a.offsetRightForSm, offsetRightForMd = _a.offsetRightForMd, offsetRightForLg = _a.offsetRightForLg, offsetRightForXl = _a.offsetRightForXl, isVisible = _a.isVisible, alignSelf = _a.alignSelf, role = _a.role, children = _a.children;
        var cssClasses = ['p-gridcol'];
        function constructClass(prop, prefix, suffix) {
            if (prop && prop !== 'None') {
                var customProp = prop.toLowerCase();
                var className = (prefix && (prefix + '-')) + customProp + (suffix && ('-' + suffix));
                cssClasses.push(className);
            }
        }
        constructClass(width, 'col', 'device-none');
        constructClass(widthForXs, 'col', 'device-xs');
        constructClass(widthForSm, 'col', 'device-sm');
        constructClass(widthForMd, 'col', 'device-md');
        constructClass(widthForLg, 'col', 'device-lg');
        constructClass(widthForXl, 'col', 'device-xl');
        constructClass(offsetLeft, 'col', 'offset-left-device-none');
        constructClass(offsetLeftForXs, 'col', 'offset-left-device-xs');
        constructClass(offsetLeftForSm, 'col', 'offset-left-device-sm');
        constructClass(offsetLeftForMd, 'col', 'offset-left-device-md');
        constructClass(offsetLeftForLg, 'col', 'offset-left-device-lg');
        constructClass(offsetLeftForXl, 'col', 'offset-left-device-xl');
        constructClass(offsetRight, 'col', 'offset-right-device-none');
        constructClass(offsetRightForXs, 'col', 'offset-right-device-xs');
        constructClass(offsetRightForSm, 'col', 'offset-right-device-sm');
        constructClass(offsetRightForMd, 'col', 'offset-right-device-md');
        constructClass(offsetRightForLg, 'col', 'offset-right-device-lg');
        constructClass(offsetRightForXl, 'col', 'offset-right-device-xl');
        constructClass(alignSelf, 'align', '');
        return isVisible && React.createElement("div", { role: role, className: cssClasses.join(' ') }, children);
    };
    return GridCol;
}(React.Component));
GridCol.defaultProps = {
    width: "None",
    widthForXs: "None",
    widthForSm: "None",
    widthForMd: "None",
    widthForLg: "None",
    widthForXl: "None",
    offsetLeft: "None",
    offsetLeftForXs: "None",
    offsetLeftForSm: "None",
    offsetLeftForMd: "None",
    offsetLeftForLg: "None",
    offsetLeftForXl: "None",
    offsetRight: "None",
    offsetRightForXs: "None",
    offsetRightForSm: "None",
    offsetRightForMd: "None",
    offsetRightForLg: "None",
    offsetRightForXl: "None",
    alignSelf: "None",
    role: null,
    isVisible: true,
    children: []
};
exports.GridCol = GridCol;
if (typeof csod == 'object' && csod.engine) {
    if (!csod.engine.controls['layout-controls'])
        csod.engine.controls['layout-controls'] = {};
    csod.engine.controls['layout-controls']['GridCol'] = GridCol;
}

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["GridCol"] = undefined;


//////////////////
// WEBPACK FOOTER
// ../player-layout-controls/controls/GridCol/index.js
// module id = 16
// module chunks = 0